import React from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';

import styles from './nextbutton.module.css';

interface NextButtonProps extends ButtonProps {
  visible: boolean,
  text?: string,
}

class NextButton extends React.Component<NextButtonProps> {

  render() {
    const { visible, text, className, ...btnProps } = this.props;
    return <div className={`${styles.buttonContainer} ${className||''} qr-btn-container`}>
    { visible && <Button type={btnProps.type||'primary'} block className={`qr-btn`} size="large" {...btnProps}>{text||'Continuar'}</Button> }
  </div>;
  }
}

export default NextButton;
